module.exports = __webpack_public_path__ + "static/media/20.017c2356.jpg";